import {InjectionToken} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {WorkbenchIpcMessage} from './workbench-ipc.types';

export const WORKBENCH_IPC_CHANNEL_NAME = new InjectionToken<string>('workbench.ipc.channelName', {
    providedIn: 'root',
    factory: () => 'webmate-workbench-ipc'
});

export type WorkbenchIpcAdapterFactory = (channelName: string) => WorkbenchIpcAdapter;

export const WORKBENCH_IPC_ADAPTER_FACTORY = new InjectionToken<WorkbenchIpcAdapterFactory>('workbench.ipc.adapterFactory', {
    providedIn: 'root',
    factory: () => (channelName: string) => new BroadcastChannelWorkbenchIpcAdapter(channelName)
});

export interface WorkbenchIpcAdapter {
    messages$: Observable<WorkbenchIpcMessage>;
    send(message: WorkbenchIpcMessage): void;
    close(): void;
}

export class BroadcastChannelWorkbenchIpcAdapter implements WorkbenchIpcAdapter {
    private messagesSubject = new Subject<WorkbenchIpcMessage>();
    messages$ = this.messagesSubject.asObservable();
    private channel: BroadcastChannel;

    constructor(channelName: string) {
        this.channel = new BroadcastChannel(channelName);
        this.channel.onmessage = event => this.messagesSubject.next(event.data as WorkbenchIpcMessage);
    }

    send(message: WorkbenchIpcMessage): void {
        this.channel.postMessage(message);
    }

    close(): void {
        this.channel.close();
        this.messagesSubject.complete();
    }
}
